import template from './flight-add-to-basket.html';
import OUT_OF_POLICY_STATUSES from './../flight-fare/fare-out-of-policy-statuses';

const DIRECTIVE_NAME = FlightAddToBasket.DIRECTIVE_NAME = 'ktFlightAddToBasket';
export default function FlightAddToBasket() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightAddToBasketController,
        controllerAs: '$ctrl',
        scope: {
            recommendation: `=${DIRECTIVE_NAME}`,
            fare: `=${DIRECTIVE_NAME}Fare`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightAddToBasketController(
    basketService,
    flightRecommendationService,
    $element,
    $scope,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isOutsideOfHoldWindow,
        cantBeAddedToBasket,
        addToBasket,
        isInBasket,
        $element,
    });
    $scope.$watch('$viewContentLoaded', function() {
        const button = $element.find('button');
        const widestSpan = _.max(button.find('span.basket'), (item) => $(item).width());
        button.width($(widestSpan).width());
    });

    function $onInit() {
    }

    function addToBasket() {
		basketService.addFlight(vm.recommendation, vm.fare, vm.selectedFlights, vm.searchParameters);
    }

    function isOutsideOfHoldWindow() {
        const [group] = flightRecommendationService.getSelectedGroupsInRecommendation(vm.recommendation, vm.selectedFlights);
        return !group.CanBeBooked;
    }

    function cantBeAddedToBasket() {
        return isInBasket()
            || isOutsideOfHoldWindow()
            || vm.fare.OutOfPolicyStatus === OUT_OF_POLICY_STATUSES.OUT_OF_POLICY_BOOKING_PROHIBITED;
    }

    function isInBasket() {
        return basketService.isFlightInBasket(vm.recommendation, vm.fare, vm.selectedFlights);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-add-to-basket/flight-add-to-basket-component.js